import React, { useState, useEffect, useContext, useRef } from "react";
import GoBack from "../../components/goBack";
import Select from "react-select";
import axios from "axios";
import { API, baseURL } from "../../services/api";
import OrgContext from "../../organisation/OrgContext";
import AuthContext from "../../components/shared/AuthContext";
import $ from "jquery";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import jwtInterceoptor from "../../components/shared/jwtInterceptor";
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";
import NewClient from "../Items/NewClient";
import moment from "moment/moment";
import { formatNumber, isNumeric } from "../../helpers/formater";
import useAuthHelper from "../../helpers/AuthHelper";

const NewFactureDepense = (props) => {
  const date_now = new Date();
  const navigate = useNavigate();
  const [t, i18n] = useTranslation();
  const { organisation, changeOrg } = useContext(OrgContext);
  const { user, logout } = useContext(AuthContext);
  const [suppliers, setSuppliers] = useState([]);
  const [products, setProducts] = useState([]);
  const [invoiceCreatedAt, setInvoiceCreatedAt] = useState(
    date_now ? moment(date_now).format("yyyy-MM-DD") : "",
  );
  const [purchaseAccounts, setPurchaseAccounts] = useState([]);
  const [taxes, setTaxes] = useState([]);
  const [invoiceStatus, setInvoiceStatus] = useState([]);

  const currentYear = new Date().getFullYear();
  const firstDayOfYear = `${currentYear}-01-01`;
  const lastDayOfYear = `${currentYear}-12-31`;

  //get form data
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [invoiceCreateDate, setInvoiceCreateDate] = useState("");
  const [selectedSupplier, setSelectedSupplier] = useState([]);
  const [selectedPurchaseAccount, setSelectedPurchaseAccount] = useState([]);
  const remarque = useRef("");
  const [selectedTaxe, setSelectedTaxe] = useState([]);
  const [qty, setQty] = useState("");
  const [unitPrice, setUnitPrice] = useState("");
  const [invoiceDueDate, setInvoiceDueDate] = useState("");
  const [selectedAttachment, setSelectedAttachment] = useState(null);
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [autoIncrementInvoiceNumber, setAutoIncrementInvoiceNumber] =
    useState(false);
  const [numeroDeLaFacture, setNumeroDeLaFacture] = useState(0);
  const fileAtta = useRef();
  const [paymentType, setPaymentType] = useState("");
  const [invoiceStatusCreatedAt, setInvoiceStatusCreatedAt] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [payedAmount, setPayedAmount] = useState(0);

  //edit facture_de_depense
  const [designation, setDesignation] = useState("");
  const [total, setTotal] = useState(0);
  const [spentAccounts, setSpentAccounts] = useState([]);

  const [banqueAccounts, setBanqueAccounts] = useState([]);
  const [bqAccountId, setBqAccountId] = useState(0);
  const [banquePaymentOption, setBanquePaymentOption] = useState("");
  const [chequeId, setChequeId] = useState("");
  const [effetId, setEffetId] = useState("");
  const [depenseAccountToEdit, setDepenseAccountToEdit] = useState([]);
  const [taxeToEdit, setTaxeToEdit] = useState([]);
  const [spentAccountToEdit, setSpentAccountToEdit] = useState("");
  const [summaryTotatlTtc, setSummaryTotatlTtc] = useState(0);
  const [caisseAccountId, setCaisseAccountId] = useState("");
  const [summaryTotatlHt, setSummaryTotatlHt] = useState(0);
  const [summaryTotalTva, setSummaryTotalTva] = useState(0);
  const [isSubmit, setIsSubmit] = useState(false);
  const [nbInvoices, setNbInvoices] = useState(0);
  const [invoicesNums, setInvoicesNums] = useState([]);
  const [numExist, setExitNum] = useState(false);

  // sous compte comptable des paiement
  const [sousCompte, setSousCompte] = useState("");
  const [sousCompteCs, setSousCompteCs] = useState("");
  const [sousComptes, setSousComptes] = useState([]);
  const [sousComptesCs, setSousComptesCs] = useState([]);

  const checkAccountAlreadyExist = (accountID) => {
    for (let i = 0; i < spentAccounts.length; i++) {
      if (spentAccounts[i].account_id === accountID) {
        return true;
      }
    }
    return false;
  };

  const fetchSousAccounts = async () => {
    await jwtInterceoptor
      .get("/data/user/bq/accounts/" + organisation.id)
      .then((res) => {
        setSousComptes(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const fetchSousAccountsCs = async () => {
    await jwtInterceoptor
      .get("/data/user/cs/accounts/" + organisation.id)
      .then((res) => {
        setSousComptesCs(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const deleteSingleSpentAccount = (spentAccountId) => {
    for (let i = 0; i < spentAccounts.length; i++) {
      if (spentAccounts[i].account_id === spentAccountId) {
        spentAccounts.splice(i, 1);
      }
    }
    setSpentAccounts([...spentAccounts]);
  };
  const editSingleSpentAccount = (spentAccountId) => {
    setSpentAccountToEdit(spentAccountId);
    $(".edit-single-product").css("display", "revert");
    $(".add-new-product-to-invoice-btn").css("display", "none");

    let spentAccount = spentAccounts.filter(
      (s_a) => s_a.account_id === spentAccountId,
    );
    console.log("loglog: ", spentAccount);
    setSelectedPurchaseAccount({
      value: spentAccount[0]["account_id"],
      label: spentAccount[0]["account_name"],
    });
    setSelectedTaxe({
      value: spentAccount[0]["taxe_id"],
      label: spentAccount[0]["taxe_name"],
      rate: spentAccount[0]["rate"],
    });

    setTotal(spentAccount[0]["total_ht"]);
    setDesignation(spentAccount[0]["designation"]);
  };
  const editSpentAccount = () => {
    if (
      selectedPurchaseAccount.value === null ||
      selectedTaxe.value === null ||
      total === 0
    ) {
      toast.error("Vérifier les champs obligatoire !", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      hideOffcanvas();
      console.log("spentAccountToEdit :", spentAccountToEdit);
      for (let i = 0; i < spentAccounts.length; i++) {
        if (spentAccounts[i].account_id === spentAccountToEdit) {
          spentAccounts[i].account_id = selectedPurchaseAccount.value;
          spentAccounts[i].account_name = selectedPurchaseAccount.label;
          spentAccounts[i].taxe_id = selectedTaxe.value;
          spentAccounts[i].taxe_name = selectedTaxe.label;
          spentAccounts[i].total_ht = total;
          spentAccounts[i].total_ttc =
            parseFloat(total) +
            (parseFloat(total) * parseFloat(selectedTaxe.rate)) / 100;
          spentAccounts[i].designation = designation;
        }
        setSpentAccounts([...spentAccounts]);
      }
    }
  };
  const hideOffcanvas = () => {
    const offcanvasElement = document.getElementById("offcanvasBottom");

    const offcanvas =
      window.bootstrap?.Offcanvas.getInstance(offcanvasElement) ||
      new window.bootstrap.Offcanvas(offcanvasElement);

    offcanvas.hide();
  };
  const validateForm = () => {
    if (
      !designation.trim() || // Vérifie que "designation" n'est pas vide
      !selectedPurchaseAccount || // Vérifie qu'un compte de dépense est sélectionné
      !selectedTaxe || // Vérifie qu'une TVA est sélectionnée
      !total ||
      isNaN(parseFloat(total)) // Vérifie que le total est un nombre valide
    ) {
      // Affiche un message d'erreur
      document.getElementById("all-fields-are-required").style.display =
        "block";
      return false; // Bloque l'exécution de la fonction principale
    }

    // Cache le message d'erreur si tous les champs sont remplis
    document.getElementById("all-fields-are-required").style.display = "none";
    return true; // Permet l'exécution
  };
  const addNewAccountToInvoice = () => {
    if (
      selectedPurchaseAccount.value === null ||
      selectedTaxe.value === null ||
      total === 0
    ) {
      toast.error("Vérifier les champs obligatoire !", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      hideOffcanvas();
      let singleSpentAccountElt = {
        account_id: selectedPurchaseAccount.value,
        account_name: selectedPurchaseAccount.label,
        taxe_id: selectedTaxe.value,
        taxe_name: selectedTaxe.label,
        rate: selectedTaxe.rate,
        total_ht: total,
        total_ttc:
          parseFloat(total) +
          (parseFloat(total) * parseFloat(selectedTaxe.rate)) / 100,
        designation: designation,
      };
      setSpentAccounts([...spentAccounts, singleSpentAccountElt]);
    }
  };
  const changeOfCanvasLayouts = () => {
    $("#all-fields-are-required").css("display", "none");
    $(".select-article").css("display", "block");
    $(".add-new-product-to-invoice-btn").css("display", "inline");
    $(".edit-single-product").css("display", "none");
    emptyInputs();
  };

  const emptyInputs = () => {
    setSelectedPurchaseAccount([]);
    setSelectedTaxe([]);
    setDesignation("");
    setTotal(0);
  };

  const getBqAccounts = async () => {
    await axios
      .get(baseURL + "/paymentAccounts")
      .then((response) => {
        setBanqueAccounts(response.data.data);
        response.data.data.map((a) => {
          if (a.name === "Banques (soldes débiteurs)") {
            setBqAccountId(a.id);
          } else if (a.name === "Caisses") {
            setCaisseAccountId(a.id);
          }
        });
        console.log("banque accout: ", banqueAccounts);
      })
      .catch((error) =>
        console.log("error while retrieving setBanqueAccounts : " + error),
      );
  };

  const getNbsInvoices = async () => {
    let resp = await jwtInterceoptor.get(
      `/data/nb-factures/factures-depense/${organisation?.id}`,
    );
    if (resp.status == 200) {
      let data = resp.data;
      if (data?.status) {
        setNbInvoices(data?.nb_factures);
        setInvoicesNums(data.data);
      }
    }
  };

  const { onlyCommercial, hadAddAccess } = useAuthHelper();

  useEffect(() => {
    $(".invoiceStatus").css("display", "none");
    $(".all-fields-are-required-to-save").css("display", "none");
    $("#warning-create-client-first").css("display", "none");
    $("#table-rows").css("display", "none");
    $("#all-fields-are-required").css("display", "none");
    $("#warning-product-already-exists").css("display", "none");
    $("#qty-is-higher").css("display", "none");

    onlyCommercial();
    hadAddAccess();
    getBqAccounts();
    getIncrementedInvoiceNumber();
    //switch diaplay block and none
    $(".some-fields-are-required-to-save").css("display", "none");
    //fournisseurs : cleints:founisseur's
    getSuppliers();
    // //compte dépenses
    //getPurchaseAccount();
    fetchAccounts();
    // //get taxes: founisseur's
    fetchTaxes();
    //
    getInvoiceStatus();
    getNbsInvoices();
    fetchSousAccounts();
    fetchSousAccountsCs();
  }, []);
  useEffect(() => {
    calcInvocieSummary();
  }, [spentAccounts]);

  const calcInvocieSummary = () => {
    let totalTva = 0;
    let totalHt = 0;
    let totalTtc = 0;
    for (let i = 0; i < spentAccounts.length; i++) {
      totalTtc += parseFloat(spentAccounts[i].total_ttc);
      totalHt += parseFloat(spentAccounts[i].total_ht);
      totalTva +=
        parseFloat(spentAccounts[i].total_ttc) -
        parseFloat(spentAccounts[i].total_ht);
    }
    setSummaryTotatlTtc(totalTtc);
    setSummaryTotatlHt(totalHt);
    setSummaryTotalTva(totalTva);
  };

  const fetchAccounts = async () => {
    const response = await jwtInterceoptor.get(
      `/data/user/accounts/${organisation.id}`,
    );

    if (response.status === 200) {
      setPurchaseAccounts(
        transformArrayToOptions4Accounts(
          response.data.data.filter(
            (account) =>
              account.code !== "34210000" &&
              account.code !== "44110000" &&
              account.code !== "51410000" &&
              account.code !== "51610000",
          ),
        ),
      );
    }
  };

  const getInvoiceStatus = async () => {
    const response = await API.get("/factures/status")
      .then((res) => {
        setInvoiceStatus(res.data.data);
      })
      .catch((error) => console.log(error));
  };
  const transformArrayToOptions = (target) => {
    let array = [];
    for (let i = 0; i < target.length; i++) {
      let obj = {
        value: target[i].id,
        label: target[i].companyName + " - " + target[i].account.code,
      };
      array.push(obj);
    }
    return array;
  };

  const transformArrayToOptions4Accounts = (target) => {
    let array = [];
    for (let i = 0; i < target.length; i++) {
      let obj = {
        value: target[i].id,
        label: target[i].name + " - " + target[i].code,
      };
      array.push(obj);
    }
    return array;
  };

  const transformArrayToOptions4Taxes = (target) => {
    let array = [];
    for (let i = 0; i < target.length; i++) {
      let obj = {
        value: target[i].id,
        label: target[i].name + " - " + target[i].code,
        rate: target[i].rate,
      };
      array.push(obj);
    }
    return array;
  };
  const getSuppliers = async () => {
    const response = await axios
      .get(
        baseURL +
          `/client/getbyuser/${user.id}/fournisseurs/${organisation.id}`,
      )
      .then((response) => {
        setSuppliers(transformArrayToOptions(response.data.data));
      })
      .catch((error) =>
        console.log("error while retrieving products by user" + error),
      );
  };
  const onFileUpload = (event) => {
    if (event.target?.files[0]) {
      console.log("event.target.files[0] : " + event.target.files[0]);
      setSelectedAttachment(event.target.files[0]);
    } else {
      console.log("else");
    }
  };
  const getPurchaseAccount = async () => {
    // We run axios, a promise is returned
    await axios
      .get(baseURL + "/purshaseaccounts")
      .then((response) => {
        setPurchaseAccounts(
          transformArrayToOptions4Accounts(response.data.data),
        );
      })
      .catch((error) =>
        console.log("error while retrieving purshaseaccounts : " + error),
      );
  };
  const fetchTaxes = async () => {
    const response = await jwtInterceoptor.get(
      `/data/organisation_taxes/${organisation.id}`,
    );

    if (response.status === 200) {
      let result = response.data.data.filter(
        (tx) =>
          tx.tax_type === "fournisseur" &&
          (tx.is_default_tax === 1 || tx.organisation_id === organisation.id),
      );
      setTaxes(transformArrayToOptions4Taxes(result));
    }
  };
  const getIncrementedInvoiceNumber = async () => {
    let value = 0;
    const response = await jwtInterceoptor
      .get("/data/user/factures_depenses/last/" + organisation.id)
      .then((res) => {
        if (res.data.data !== null) {
          console.log("getIncrementedInvoiceNumber: ", res.data.data.id);
          setNumeroDeLaFacture(res.data.data.id + 1);
        } else {
          setNumeroDeLaFacture(1);
        }
      })
      .catch((error) => console.log("error while save", error));
  };
  const save = async (event) => {
    event.preventDefault();
    let isOkToSave = true;
    isOkToSave = !(
      selectedStatus === "" ||
      selectedStatus === 0 ||
      spentAccounts.length === 0 ||
      invoiceDueDate.length === 0 ||
      invoiceCreatedAt.length === 0 ||
      selectedSupplier.value === undefined ||
      (autoIncrementInvoiceNumber === false && invoiceNumber === "")
    );
    console.log("1", isOkToSave);
    //etat= payé
    if (
      selectedStatus === "2" &&
      (paymentType.length === 0 || invoiceStatusCreatedAt.length === 0)
    ) {
      isOkToSave = false;
    }

    if (
      selectedStatus === "2" &&
      paymentType.length !== 0 &&
      invoiceStatusCreatedAt.length !== 0
    ) {
      if (paymentType === caisseAccountId.toString()) {
        isOkToSave = true;
      } else {
        if (banquePaymentOption.length === 0) {
          isOkToSave = false;
        } else {
          if (banquePaymentOption === "chéque" && chequeId.length === 0) {
            isOkToSave = false;
          }
        }
      }
    }

    //etat = payé en partie
    if (
      selectedStatus === "3" &&
      (paymentType.length === 0 || invoiceStatusCreatedAt.length === 0)
    ) {
      isOkToSave = false;
    }

    if (
      selectedStatus === "3" &&
      paymentType.length !== 0 &&
      invoiceStatusCreatedAt.length !== 0
    ) {
      if (paymentType !== bqAccountId && payedAmount === 0) {
        isOkToSave = false;
      } else {
        if (paymentType === bqAccountId && banquePaymentOption.length === 0) {
          isOkToSave = false;
        } else {
          if (banquePaymentOption === "chéque" && chequeId.length === 0) {
            isOkToSave = false;
          }
        }
      }
    }

    if (
      selectedStatus === "3" &&
      paymentType.length !== 0 &&
      payedAmount === 0 &&
      invoiceStatusCreatedAt.length !== 0
    ) {
      isOkToSave = false;
    }

    if (
      paymentType.length !== 0 &&
      paymentType === bqAccountId.toString() &&
      (sousCompte.length === 0 || sousCompte === 0)
    ) {
      isOkToSave = false;
    }

    if (
      paymentType.length !== 0 &&
      paymentType === caisseAccountId.toString() &&
      (sousCompteCs.length === 0 || sousCompteCs === 0 || sousCompteCs === "0")
    ) {
      isOkToSave = false;
    }

    if (invoiceNumber.length > 0) {
      isOkToSave = !numExist;
    }

    if (isOkToSave) {
      let is_custom_invoice_number = 0;
      let numeroDeFacture = "";

      if (autoIncrementInvoiceNumber === false) {
        is_custom_invoice_number = 1;
        numeroDeFacture = isNumeric(invoiceNumber)
          ? `FACT-DEPENSE-${formatNumber(invoiceNumber)}`
          : `FACT-DEPENSE-${invoiceNumber}`;
      } else {
        numeroDeFacture = `FACT-DEPENSE-${nbInvoices + 1}`;
      }

      /**
       *
       * @type {FormData}
       */
      let formData = new FormData();
      formData.append("user_id", user.id);
      formData.append("organisation_id", organisation.id);
      formData.append("supplier_id", selectedSupplier.value);
      formData.append("total_ttc", summaryTotatlTtc);
      formData.append("total_ht", summaryTotatlHt);
      formData.append("total_tva", summaryTotalTva);
      formData.append("due_date", invoiceDueDate);
      formData.append("invoice_number", numeroDeFacture);
      formData.append("is_custom_invoice_number", is_custom_invoice_number);
      formData.append("attachment_file", selectedAttachment);
      formData.append("status", selectedStatus);
      formData.append("created_at_date", invoiceCreatedAt);
      formData.append("spent_accounts", JSON.stringify(spentAccounts));
      formData.append("payed_invoice_created_at", invoiceStatusCreatedAt);

      formData.append("payed_amount", Number(payedAmount).toFixed(2));
      //formData.append("payment_account", sousCompte);

      if (paymentType === bqAccountId.toString()) {
        formData.append("payment_account", sousCompte);
      } else if (paymentType === caisseAccountId.toString()) {
        formData.append("payment_account", sousCompteCs);
      } else {
        formData.append("payment_account", paymentType);
      }

      //formData.append("payment_account", paymentType);
      if (paymentType === bqAccountId.toString()) {
        formData.append("banquePaymentOption", banquePaymentOption);
        if (banquePaymentOption == "effet") {
          formData.append("effetId", effetId);
          console.log("effet", effetId);
        } else {
          formData.append("chequeId", chequeId);
        }
      } else {
        formData.append("banquePaymentOption", "");
        formData.append("chequeId", "");
        formData.append("effetId", "");
      }

      setIsSubmit(true);
      const response = await jwtInterceoptor
        .post("/data/user/factures_depenses/add", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          setIsSubmit(false);
          Swal.fire(
            t("La facture de dépense a été créée avec succès."),
            // Correction de la faute d’orthographe
            t(""),
            "success",
          );
          navigate("/depense/facturedepense/list");
        })
        .catch((error) => {
          setIsSubmit(false);
          console.log("error while save", error);
        });
    } else {
      const errorMessage = "Merci de remplir tout les champs obligatoire !";
      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const handleAutoIncrementInvoiceNumber = () => {
    if (autoIncrementInvoiceNumber === false) {
      $("#invoiceNumberInput").css("display", "none");
    } else {
      $("#invoiceNumberInput").css("display", "block");
    }
  };

  const handleInvoiceStatusCreatedAtChange = (e) => {
    const selectedDate = e.target.value;
    setInvoiceStatusCreatedAt(selectedDate);

    if (!invoiceDueDate) {
      toast.error("La date d'échéance n'est pas encore fixée !", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      setInvoiceStatusCreatedAt("");
      return;
    }

    const createdAtDate = new Date(selectedDate);
    const dueDate = new Date(invoiceDueDate);

    if (createdAtDate < dueDate) {
      toast.warn(
        "la date de paiement que vous avez choisie est antérieure à la date d'échéance, Veuillez vérifier la date ou confirmer cette opération",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
        },
      );
    }
  };

  const onSaveClient = () => {
    getSuppliers();
    window.$("#newClientModal").modal("hide");
    console.log("has been saved");
    Swal.fire(t("Le fournisseur a été ajouter avec succès"), t(""), "success");
  };

  return (
    <>
      <div className="main-container container-fluid">
        <GoBack route={"/depense/facturedepense/list"} />

        <div className="page-header">
          <h1 className="page-title breadcumpsHeader">Facture de depense</h1>
          <div>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a
                  href="javascript:void(0)"
                  onClick={() => navigate("/depense/facturedepense/list")}
                >
                  Liste des facture de depense
                </a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Ajouter une facture de depense
              </li>
            </ol>
          </div>
        </div>
      </div>
      <div className="row">
        <ToastContainer />

        <div className="col-xl-12">
          <div className="card">
            <div className="card-body">
              <div
                className="alert alert-danger alert-dismissible fade show mb-0 some-fields-are-required-to-save"
                role="alert"
              >
                <span className="alert-inner--icon">
                  <i className="fe fe-slash"></i>
                </span>
                <span className="alert-inner--text">
                  <strong></strong>Attention ! Les champs suivants sont
                  obligatoire.
                </span>
                <p>
                  - Date de création <br />
                  - L'état de la factrue <br />
                  - Mode de réglement <br />
                  - le fournisseur concérner <br />
                  - Date de création <br />
                  - Le compte de dépenses,taxe et totale <br />
                </p>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <br />
              <div
                className="modal fade"
                id="newClientModal"
                tabIndex="-1"
                aria-labelledby="newClientModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-xl">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h1 className="modal-title fs-5" id="newClientModal">
                        Ajouter un nouveaux fournisseur
                      </h1>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body">
                      <NewClient
                        clientType={"fournisseurs"}
                        from={"new_fv"}
                        handleSave={onSaveClient}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <h4>{t("Espace Fournisseur")}</h4>
              <div className={"row"}>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      Choisir le fournisseur*
                    </label>
                    <Select
                      options={suppliers}
                      onChange={(choice) => setSelectedSupplier(choice)}
                    />
                  </div>
                </div>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      Nouveau fournisseur
                    </label>
                    <a
                      className="btn btn-primary form-control"
                      data-bs-toggle="modal"
                      data-bs-target="#newClientModal"
                    >
                      <i className="fe fe-user"></i> ajouter un fournisseur
                    </a>
                  </div>
                </div>
              </div>
              <hr className={"custom-hr"} />
              <h4>Informations sur la facture</h4>
              <hr className={"custom-hr"} />
              <div className={"row"}>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      N° de la facture * (
                      {t(
                        "ce numéro servira de référence pour votre facture originale",
                      )}
                      )
                    </label>
                    <input
                      type="text"
                      placeholder="Fac-0001"
                      className={`form-control `}
                      onChange={(e) => {
                        setInvoiceNumber(e.target.value);
                        let numExist = invoicesNums.findIndex(
                          (c) =>
                            e.target.value == c?.invoice_number ||
                            e.target.value ==
                              (c.is_custom_invoice_number == 1
                                ? c.invoice_number
                                : `Fact-depense-${formatNumber(c?.invoice_number)}`),
                        );
                        if (numExist != -1) {
                          setExitNum(true);
                        } else {
                          setExitNum(false);
                        }
                      }}
                      value={invoiceNumber}
                      id={"invoiceNumberInput"}
                    />
                    {!autoIncrementInvoiceNumber && numExist ? (
                      <span className={"text-danger"}>
                        {t("Ce numéro de facture existe déjà")}
                      </span>
                    ) : null}
                    <label className="custom-control custom-checkbox-md">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        name="example-checkbox5"
                        value="option5"
                        checked={autoIncrementInvoiceNumber}
                        onClick={() =>
                          setAutoIncrementInvoiceNumber(
                            !autoIncrementInvoiceNumber,
                          )
                        }
                        onChange={(e) => {
                          handleAutoIncrementInvoiceNumber();
                        }}
                      />
                      <span className="custom-control-label">
                        Utiliser le numéro de facture auto-incrementer
                      </span>
                    </label>
                  </div>
                </div>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      date de facture*
                    </label>
                    <input
                      type="date"
                      placeholder="nom"
                      className={`form-control `}
                      onChange={(e) => setInvoiceCreatedAt(e.target.value)}
                      value={invoiceCreatedAt}
                      //min={firstDayOfYear}
                      //max={lastDayOfYear}
                    />
                  </div>
                </div>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      date d'échéance*
                    </label>
                    <input
                      type="date"
                      placeholder="nom"
                      className={`form-control `}
                      onChange={(e) => setInvoiceDueDate(e.target.value)}
                      value={invoiceDueDate}
                      min={firstDayOfYear}
                    />
                  </div>
                </div>
              </div>

              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">DESIGNATION</th>
                    <th scope="col">COMPTE DE DÉPENSES</th>
                    <th scope="col">TAXE</th>
                    <th scope="col">Total HT</th>
                    <th scope="col">Total TTC</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                {spentAccounts.map((spent) => {
                  return (
                    <tr key={spent.account_id}>
                      <td>{spent.designation}</td>
                      <td>{spent.account_name}</td>
                      <td>{spent.taxe_name}</td>
                      <td>{Number(spent.total_ht).toFixed(2)}</td>
                      <td>{Number(spent.total_ttc).toFixed(2)}</td>
                      <td>
                        <i
                          onClick={() =>
                            deleteSingleSpentAccount(spent.account_id)
                          }
                          className="fe fe-trash"
                        ></i>
                      </td>
                      <td>
                        <i
                          data-bs-toggle="offcanvas"
                          aria-controls="offcanvasBottom"
                          data-bs-target="#offcanvasBottom"
                          onClick={() =>
                            editSingleSpentAccount(spent.account_id)
                          }
                          className="fe fe-edit"
                        ></i>
                      </td>
                    </tr>
                  );
                })}
              </table>
              <center>
                <button
                  onClick={changeOfCanvasLayouts}
                  className="btn btn-primary off-canvas btn-sm mb-1"
                  type="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasBottom"
                  aria-controls="offcanvasBottom"
                >
                  <i className="fe fe-plus"></i>
                  ajouter une depense
                </button>
              </center>

              <hr className={"custom-hr"} />
              <div className={"row"}>
                <div className={"col-md-6"}></div>
                <div className={"col-md-6 d-flex flex-row-reverse"}>
                  <div className="row">
                    <div className="invoiceSummary">
                      <table>
                        <tr>
                          <td className={"invoiceSummary-base"}>Total HT :</td>
                          <td>
                            {Number(summaryTotatlHt).toFixed(2)}{" "}
                            {organisation?.currency?.code}
                          </td>
                        </tr>
                        <tr>
                          <td className={"invoiceSummary-base"}>Total TVA :</td>
                          <td>
                            {Number(summaryTotalTva).toFixed(2)}{" "}
                            {organisation?.currency?.code}
                          </td>
                        </tr>
                        <tr>
                          <td className={"invoiceSummary-base"}>Total TTC :</td>
                          <td>
                            {Number(summaryTotatlTtc).toFixed(2)}{" "}
                            {organisation?.currency?.code}
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div className={"row"}>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="form-label">
                      Etat*
                    </label>
                    <select
                      className="form-select form-select-lg"
                      id="buyPriceAccountInput"
                      onChange={(e) => setSelectedStatus(e.target.value)}
                      value={selectedStatus}
                    >
                      <option value="0">
                        sélectionner l'état de la facture
                      </option>
                      {invoiceStatus.map((status) => {
                        return <option value={status.id}>{status.name}</option>;
                      })}
                    </select>
                  </div>
                  <div
                    className="paymentSection"
                    style={{
                      display:
                        selectedStatus === "2" || selectedStatus === "3"
                          ? "block"
                          : "none",
                    }}
                  >
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1" className="">
                        Date de règlement*
                      </label>
                      <input
                        type="date"
                        placeholder="nom"
                        className={`form-control `}
                        onChange={handleInvoiceStatusCreatedAtChange}
                        value={invoiceStatusCreatedAt}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1" className="">
                        Banque ou Caisse*
                      </label>
                      <select
                        className="form-select"
                        id="buyPriceAccountInput"
                        onChange={(e) => {
                          setPaymentType(e.target.value);
                          console.log("paymùslkdnb;s,:", e.target.value);
                        }}
                        value={paymentType}
                      >
                        <option value="0">
                          selectionner un mode de réglement
                        </option>
                        {banqueAccounts.map((account) => (
                          <option
                            value={account.id}
                            onClick={() => console.log("ffdfdfd")}
                          >
                            {account.code + " - " + account.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div
                      className="form-group"
                      style={{
                        display:
                          paymentType === "" + bqAccountId + ""
                            ? "block"
                            : "none",
                      }}
                    >
                      <label htmlFor="sousCompte" className="">
                        Sous Compte*
                      </label>
                      <select
                        className="form-select"
                        id="sousCompte"
                        onChange={(e) => {
                          setSousCompte(e.target.value);
                        }}
                        value={sousCompte}
                      >
                        <option value="0">selectionner un sous compte</option>
                        {sousComptes.map((account) => (
                          <option value={account.id}>
                            {account.code + " - " + account.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div
                      className="form-group"
                      style={{
                        display:
                          paymentType === "" + caisseAccountId + ""
                            ? "block"
                            : "none",
                      }}
                    >
                      <label htmlFor="sousCompte" className="">
                        Sous Compte*
                      </label>
                      <select
                        className="form-select"
                        id="sousCompte"
                        onChange={(e) => {
                          setSousCompteCs(e.target.value);
                        }}
                        value={sousCompteCs}
                      >
                        <option value="0">selectionner un sous compte</option>
                        {sousComptesCs.map((account) => (
                          <option value={account.id}>
                            {account.code + " - " + account.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="banqueOptions">
                      <div
                        className="verementOrChéque"
                        style={{
                          display:
                            paymentType === "" + bqAccountId + ""
                              ? "block"
                              : "none",
                        }}
                      >
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1" className="">
                            Mode de Réglement *
                          </label>
                          <select
                            className="form-select"
                            id="buyPriceAccountInput"
                            onChange={(e) =>
                              setBanquePaymentOption(e.target.value)
                            }
                            value={banquePaymentOption}
                          >
                            <option value="0">
                              selectionner un mode de réglement
                            </option>
                            <option value="virement">Virement</option>
                            <option value="chéque">Chéque</option>
                            <option value="carte bancaire">
                              Carte Bancaire
                            </option>
                            <option value="effet">Effet</option>
                            <option value="prélévement">Prélévement</option>
                          </select>
                        </div>
                      </div>
                      <div
                        className="libelleIfcheque"
                        style={{
                          display:
                            banquePaymentOption === "chéque" &&
                            paymentType === "" + bqAccountId + ""
                              ? "block"
                              : "none",
                        }}
                      >
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1" className="">
                            Identificateur du chéque*
                          </label>
                          <input
                            type="text"
                            placeholder=""
                            className={`form-control `}
                            onChange={(e) => setChequeId(e.target.value)}
                            value={chequeId}
                          />
                        </div>
                      </div>
                      <div
                        className="libelleIfcheque"
                        style={{
                          display:
                            banquePaymentOption === "effet" &&
                            paymentType === "" + bqAccountId + ""
                              ? "block"
                              : "none",
                        }}
                      >
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1" className="">
                            Identificateur d'effet*
                          </label>
                          <input
                            type="text"
                            placeholder=""
                            className={`form-control `}
                            onChange={(e) => setEffetId(e.target.value)}
                            value={effetId}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className="form-group"
                      style={{
                        display: selectedStatus === "3" ? "block" : "none",
                      }}
                    >
                      <label htmlFor="exampleInputEmail1" className="">
                        Montant payé*
                      </label>
                      <input
                        type="text"
                        placeholder="objet"
                        className={`form-control `}
                        onChange={(e) => {
                          if (e.target.value >= summaryTotatlTtc) {
                            setPayedAmount(0);
                            toast.error(
                              "le mantant payé remplit est supérieur ou égale le total ttc",
                              {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: false,
                                draggable: true,
                                progress: undefined,
                                theme: "colored",
                              },
                            );
                          } else {
                            setPayedAmount(e.target.value);
                          }
                        }}
                        value={payedAmount}
                      />
                    </div>
                  </div>
                </div>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label className="form-label">
                      Glissez ou déplacez le reçus (
                      <span className="text-red">
                        Fichier PDF/Image, taille Max 2 Mo
                      </span>
                      )
                    </label>
                    <input
                      className="form-control form-control-lg"
                      type="file"
                      onChange={onFileUpload}
                      ref={fileAtta}
                    />
                  </div>
                </div>
              </div>

              <br />
              <div className="card-footer">
                <div className="d-flex flex-row-reverse">
                  <button
                    disabled={isSubmit}
                    type={"button"}
                    className="btn btn-primary"
                    onClick={save}
                  >
                    {isSubmit ? t("Loading ...") : t("Enregistrer")}
                  </button>
                  <a
                    onClick={() => {
                      navigate(-1);
                    }}
                    className="btn btn-default"
                    style={{ marginRight: 10 }}
                  >
                    Annuler
                  </a>
                </div>
              </div>

              <div
                className="offcanvas offcanvas-bottom addProductCanvas"
                tabIndex="-1"
                id="offcanvasBottom"
                aria-labelledby="offcanvasBottomLabel"
              >
                <div className="offcanvas-header">
                  <h5 className="offcanvas-title" id="offcanvasBottomLabel">
                    Ajouter le compte de depense
                  </h5>
                  <button
                    type="button"
                    className="btn-close text-reset"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                  >
                    <i className="fe fe-x fs-18"></i>
                  </button>
                </div>
                <div className="offcanvas-body">
                  <div id="all-fields-are-required">
                    <div
                      class="alert alert-danger alert-dismissible fade show mb-0"
                      role="alert"
                    >
                      <span class="alert-inner--icon">
                        <i class="fe fe-slash"></i>
                      </span>
                      <span class="alert-inner--text">
                        <strong>Attention!</strong> Tous les champs sont
                        obligatoire !
                      </span>
                    </div>
                    <br />
                  </div>

                  <div id="warning-product-already-exists">
                    <div
                      class="alert alert-danger alert-dismissible fade show mb-0"
                      role="alert"
                    >
                      <span class="alert-inner--icon">
                        <i class="fe fe-slash"></i>
                      </span>
                      <span class="alert-inner--text">
                        <strong>Attention!</strong> Le produit déja exist !
                      </span>
                    </div>
                    <br />
                  </div>
                  <form className="needs-validation" noValidate="">
                    <div className="form-row">
                      <div className="col-xl-12 mb-12">
                        <label htmlFor="validationTooltip02">
                          DESIGNATION*
                        </label>
                        <textarea
                          className={`form-control `}
                          onChange={(e) => setDesignation(e.target.value)}
                          value={designation}
                        ></textarea>
                      </div>
                      <div className="col-xl-12 mb-3">
                        <label
                          className={"select-article"}
                          htmlFor="validationTooltip01"
                        >
                          COMPTE DE DEPENSE*
                        </label>
                        <Select
                          value={selectedPurchaseAccount}
                          maxMenuHeight={100}
                          className={"select-article"}
                          options={purchaseAccounts}
                          onChange={(choice) => {
                            setSelectedPurchaseAccount(choice);
                          }}
                        />
                      </div>
                      <div className="col-xl-12 mb-3">
                        <label
                          className={"select-article"}
                          htmlFor="validationTooltip01"
                        >
                          TVA*
                        </label>
                        <Select
                          value={selectedTaxe}
                          maxMenuHeight={100}
                          options={taxes}
                          onChange={(choice) => setSelectedTaxe(choice)}
                        />
                      </div>
                      <div className="col-xl-12 mb-12">
                        <label htmlFor="validationTooltip02">Total HT*</label>
                        {/* remplacer Total par Total HT */}
                        <input
                          type="number"
                          className="form-control"
                          id="validationTooltip02"
                          required=""
                          value={total}
                          onChange={(e) => {
                            const value = e.target.value;

                            // Allow only numeric input with optional decimal point
                            const formattedValue = value.replace(
                              /[^0-9.]/g,
                              "",
                            );

                            // Ensure only one decimal point is allowed
                            if ((formattedValue.match(/\./g) || []).length > 1)
                              return;

                            setTotal(formattedValue); // Update the state without formatting yet
                          }}
                          onBlur={() => {
                            // Format the value to two decimal places on blur
                            if (!isNaN(parseFloat(total))) {
                              setTotal(parseFloat(total).toFixed(2));
                            } else {
                              setTotal(""); // Reset if the value is invalid
                            }
                          }}
                        />
                      </div>
                      <br />
                      <br />
                      <br />
                      <br />
                    </div>
                    <button
                      className=" btn btn-primary add-new-product-to-invoice-btn"
                      onClick={(event) => {
                        event.preventDefault();

                        if (validateForm()) {
                          addNewAccountToInvoice(); // Appelle la fonction principale si la validation réussit
                        }
                      }}
                    >
                      Valider
                    </button>
                    <i
                      className="fe fe-edit btn btn-primary edit-single-product"
                      onClick={() => {
                        if (validateForm()) {
                          editSpentAccount(); // Appelle la fonction principale si la validation réussit
                        }
                      }}
                    ></i>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewFactureDepense;
